<template>
<div class="group relative rounded-3xl border border-app bg-card transition-all duration-300 hover:border-brand-500/50 hover:shadow-2xl hover:shadow-brand-500/10 hover:-translate-y-2 overflow-hidden flex flex-col">
    <div class="relative h-56 bg-muted overflow-hidden">
        <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.title"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
        <div v-else
            class="w-full h-full bg-gradient-to-br from-brand-500/20 to-primary-500/20 flex items-center justify-center transition-transform duration-700 group-hover:scale-105">
            <Megaphone
                class="h-16 w-16 text-brand-500/40 transform group-hover:-rotate-12 transition-transform duration-500" />
        </div>
        <div v-if="item.memberOnly" class="absolute top-4 left-4">
            <span
                class="px-3 py-1.5 rounded-full bg-brand-500 text-white text-[10px] font-bold uppercase shadow-lg backdrop-blur-md border border-white/20">Member
                Only</span>
        </div>
        <div class="absolute bottom-4 left-4">
            <span
                class="px-3 py-1.5 rounded-lg bg-black/70 backdrop-blur-md text-white text-[10px] font-bold tracking-widest shadow-lg border border-white/10">{{
                    $filter && $filter.day ? $filter.day(item.createdAt) : getMonth(item.createdAt)
                        + ' ' + getDayNum(item.createdAt) }}</span>
        </div>
    </div>
    <div class="p-8 flex-1 flex flex-col relative bg-card">
        <h4
            class="text-xl font-bold text-header mb-4 group-hover:text-brand-500 transition-colors line-clamp-2 leading-snug">
            {{ item.title }}</h4>
        <div class="text-body/80 text-sm leading-relaxed mb-6 line-clamp-3"
            v-html="item.content ? item.content.replace(/<[^>]*>?/gm, '') : ''"></div>

        <div class="mt-auto pt-6 border-t border-app/50 flex items-center justify-between">
            <span class="text-xs font-bold text-body/80 flex items-center gap-1.5">
                <Clock class="h-3.5 w-3.5 opacity-70" /> Updated {{ $filter && $filter.day ?
                    $filter.day(item.updatedAt) : getMonth(item.updatedAt) + ' ' +
                    getDayNum(item.updatedAt) }}
            </span>
            <NuxtLink :to="{ name: 'UpdateSingle', params: { id: item.id } }"
                class="text-brand-500 hover:text-white hover:bg-brand-500 transition-all bg-brand-500/10 p-2.5 rounded-full shadow-sm">
                <ArrowRight class="h-4 w-4" />
            </NuxtLink>
        </div>
    </div>
</div>
</template>

<script lang="ts" setup>
import {
    Megaphone,
    Calendar,
    Target,
    LayoutGrid,
    MapPin,
    ArrowRight,
    Clock,
} from 'lucide-vue-next';

const props = defineProps<{
    item: Record<string, any>;
}>();

// Helper functions for dates since $filter.day might just return ISO or localized simple string.
const getMonth = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleString('default', { month: 'short' });
    } catch (e) { return ''; }
}
const getDayNum = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.getDate();
    } catch (e) { return ''; }
}
const formatTime = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
}
</script>

<style lang="scss" scoped>

</style>